<template>
    <table id="tabela" class="table table-striped">
        <thead>
            <th class="fs-3" colspan="7">
                {{ titulo }}
            </th>
            <tr>
                <td v-for="col in cabecalho" :key="col.id" :data-nome="col.nome"> {{ col.titulo }} </td>
                <td></td>
            </tr>
        </thead>
        <tbody id="linhas">
            <tr v-for="ln in lstLinhas" :key="ln.Id">
                <td v-for="col in cabecalho" :key="col.id" class="">{{ retornaValorLinha(col.nome, ln) }} </td>
                <td><button class="btn btn-info" @click="limpar(ln)"> Limpar </button></td>
            </tr>
        </tbody>

    </table>

    <ModalConfirmaAgape :title="'ATENÇÃO'" :visible="state.comMensagem" :text="state.mensagem" :id="state.codigoLeito"
        @modalResult="modalConfirma">
        <template v-slot:motivo>
            <h4>Escreva o motivo abaixo</h4>
            <textarea class="form-control" v-model="state.motivo" cols="30" rows="2" maxlength="200"></textarea>
        </template>
    </ModalConfirmaAgape>
</template>

<script setup>
import store from '@/store/store';
import api from '@/api/api';
import ModalConfirmaAgape from '@/components/ModalConfirmaAgape.vue';
import { frontUrl } from "@/api/const";
import { reactive, onMounted, computed, defineProps } from 'vue';

onMounted(() => {
    atualizarLista();
});

const props = defineProps(['cabecalho', 'linhas', 'titulo', 'campos']);

const state = reactive({
    alteracaoSelecionada: null,
    camposTemp: [],
    lsttmp: [],
    frontUrl: frontUrl,
    lstLinhas: [],
    codigoLeito: 0,
    comMensagem: false,
    funcLimpar: false,
    mensagem: "",
    self: {},
    motivo: "",
});

function retornaValorLinha(col, ln) {
    if (col === "link") {
        return `${frontUrl}/#/${ln.id}`;
    }
    if (typeof (ln[col]) === 'object') {
        return (ln[col] == null) ? "Não" : ln[col].descricao;
    } else {
        return ln[col];
    }
}

function excluirLinha(id) {
    let vetTemp = [];

    state.lstLinhas.forEach((chamado) => {
        if (chamado.id != id)
            vetTemp.push(chamado);
    });

    state.lstLinhas = vetTemp;

}

function limpar(ln) {
    state.codigoLeito = ln.id;
    state.funcLimpar = true;
    state.mensagem =
        "Deseja limpar todos os chamados abertos com leito de código " + ln.id + " ?";
    state.comMensagem = true;

}

async function atualizarLista() {
    let dados;
    state.lstLinhas = [];
    dados = await api.listarLeitoComChamado();
    if (dados && dados.length > 0) {
        dados.forEach(dado => {
            state.lstLinhas.push(dado);
        });
    }
}

function fechar() {
    state.mensagem = String();
    state.comMensagem = false;
}

function modalConfirma(result, id) {
    if (state.funcLimpar && result == "ok") {
        excluirLinha(id);
        api.chamadoLimparLeito(state.motivo, state.codigoLeito)
            .then()
            .catch();
    }
    state.motivo = "";
    state.funcLimpar = false;
    state.mensagem = "";
    state.comMensagem = false;
}

const config = computed(() => {
    return store.state.config;
});
</script>

<style scoped>
.card {
    width: auto;
    min-width: 200px;
    font-family: sans-serif;
}

.card-aberto {
    max-height: 200px !important;
}

.card-text,
.card-title,
.data,
.card-header {
    font-weight: bold;
    font-size: 1.3em;
    margin: 0;
}

.card-header {
    /*background-color: rgba(100, 100, 100, 0.2);*/
    background-color: rgba(12, 139, 27, 0.6);
}

.card-body {
    background-color: rgba(18, 203, 40, 0.6);
    /*background-color: rgba(255, 255, 255, 0.2);*/
}

.card-header {
    text-align: left;
    color: rgba(50, 50, 50, 0.75);
}

.card-body .card-text {
    text-align: left;
}

.card {
    box-shadow: 0px 10px 14px rgba(9, 82, 43, 0.2);
    min-width: 300px !important;
}

.card-body {
    display: flex !important;
    flex-direction: column;
    justify-content: top;
}


@media only screen and (max-width : 616px) {
    .card {
        width: auto;
        min-width: 430px;
        /*min-height: 225px;*/
        font-family: sans-serif;
    }
}

@media only screen and (max-width: 432px) {
    .card {
        /*width: auto;
        min-height: auto;*/
        min-width: 100%;
    }
}
</style>